import { TruClose } from '@uswitch/spark-icons/tru';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { jsxs as _jsxs } from "theme-ui/jsx-runtime";

var Modal = function Modal(_ref) {
  var children = _ref.children,
      close = _ref.close,
      isOpen = _ref.isOpen,
      type = _ref.type,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'default' : _ref$variant;

  var getStyles = function getStyles(element) {
    return "elements.modal.variants.".concat(variant).concat(element ? '.' + element : '');
  };

  var handleKeypress = function handleKeypress(_ref2) {
    var key = _ref2.key;
    return (key === 'Enter' || key === 'Escape') && close();
  };

  return _jsx("div", {
    sx: {
      position: 'fixed',
      backgroundColor: 'rgba(0,0,0,0.5)',
      top: 0,
      right: 0,
      left: 0,
      bottom: 0,
      display: isOpen ? 'flex' : 'none',
      justifyContent: 'center',
      alignItems: 'center',
      p: 'sm',
      zIndex: 110,
      variant: getStyles()
    },
    onClick: close,
    onKeyPress: handleKeypress,
    role: "link",
    tabIndex: 0,
    children: _jsxs("div", {
      sx: {
        width: type === 'calculator' ? ['90%', '50%'] : '100%',
        maxWidth: [500, 1300],
        maxHeight: '100%',
        backgroundColor: 'white',
        position: 'relative',
        overflowY: 'auto',
        variant: getStyles('content')
      },
      children: [_jsx("div", {
        sx: {
          position: 'absolute',
          top: 'md',
          right: 'md',
          variant: getStyles('icon')
        },
        children: _jsx(TruClose, {
          color: 'rgba(0,0,0,0.6)',
          size: 18
        })
      }), children]
    })
  });
};

export default Modal;
//# sourceMappingURL=index.js.map